import { ICreateObraEstruturaOrganizacionalUseCase } from "../../../presentation/useCases/create/create_obra_estrutura_organizacional_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateObraEstruturaOrganizacionalUseCase
 */

export class CreateObraEstruturaOrganizacionalUseCase implements ICreateObraEstruturaOrganizacionalUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createObraEstruturaOrganizacional(
    idObra: number,
    idFuncionario: number,
    idCargo: number,
  ): Promise<void> {
    await this.repository.createObraEstruturaOrganizacional(
      idObra,
      idFuncionario,
      idCargo,
    );
  }
}
